import React from "react";
import ContactUsForm from "../components/ContactUsForm";
import { useUser } from '../contexts/UserContext';

const ContactUsPage = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { user } = useUser();

  const handleNewContactUs = async (contactUsData) => {
    try {
      // Add userId to transaction data
      const enrichedTransactionData = {
        ...contactUsData,
        userId: user.id,
      };

      const response = await fetch(`${API_BASE_URL}contactUs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(enrichedTransactionData),
      });
      const newContactUs = await response.json();
      console.log('respo', newContactUs);
    } catch (error) {
      console.error("Error creating contact us record:", error);
    }
  };

  return (
    <div
      className="p-6"
      style={{ backgroundColor: "#C6D2ED", minHeight: "100vh" }}
    >
      <ContactUsForm onSubmit={handleNewContactUs} />
    </div>
  );
};

export default ContactUsPage;
